import React from 'react';

import {black, secondary, primary, white} from "../themes/colors";
import {isMobile} from "../utils/screenUtility";
import DefaultContentJoyride from "../containers/joyride/DefaultContentJoyride";
import MollyVideoJoyride from "../containers/joyride/MollyIntroJoyride";

export const DEFAULT_USER_GUIDE = [
    {
        routeKey: '/home/select',
        stepIndex: 0,
        runGuide: true,
        steps: [
            {
                target: '.add-student-btn',
                content: <DefaultContentJoyride lineIds={['guide.content.addStudent']}/>,
                disableBeacon: true,
                isFixed: true,
                offset: 16
            }
        ]
    },
    {
        routeKey: '/home/select/student/:id',
        label: 'Timeline Intro',
        index: 0,
        stepIndex: 0,
        runGuide: true,
        skipped: false,
        steps: [
            {
                target: '.student-details',
                label: 'Timeline',
                content: <MollyVideoJoyride/>,
                disableBeacon: true,
                isFixed: true,
                styles: {
                    tooltip: {
                        width: '100%',
                        maxWidth: '100%',
                        backgroundColor: white
                    },
                    buttonClose: {
                        stroke: black
                    },
                    tooltipFooter: {
                        display: 'none'
                    },
                    options: {
                        arrowColor: secondary
                    }
                },
                placement: 'center'
            },
            {
                target: '.student-details',
                label: 'Timeline',
                content: <DefaultContentJoyride tourTitle='joyride.guide.1.step.tour-title'
                                                stepTitle={'joyride.guide.1.step.timeline.step-title'}
                                                lineIds={['joyride.guide.1.step.timeline.text']}
                                                step={'1/2'}/>,
                disableBeacon: true,
                hideBackButton: true,
                showSkipButton: false,
                isFixed: true,
                styles: {}
                // placement: 'bottom-start'
            }, {
                target: isMobile() ? '.assignments-create' : '.timeline-create-btn',
                label: 'Plus Button',
                content: <DefaultContentJoyride tourTitle='joyride.guide.1.step.tour-title'
                                                stepTitle={'joyride.guide.1.step.newlesson.step-title'}
                                                lineIds={['joyride.guide.1.step.newlesson.text.1', 'joyride.guide.1.step.newlesson.text.2']}
                                                styles={{
                                                    'joyride.guide.1.step.newlesson.text.2': {
                                                        color: primary,
                                                        fontSize: 16,
                                                        fontWeight: 'bold',
                                                        lineHeight: '22px'
                                                    }
                                                }}
                                                step={'2/2'}/>,
                disableBeacon: true,
                styles: {
                    buttonNext: {
                        display: 'none'
                    },
                    buttonBack: {
                        position: 'absolute',
                        left: 5
                    }
                }
            }
        ]
    },
    {
        routeKey: '/create',
        routeParams: '?guide=true&tabIndex=0',
        label: 'Studio Overview',
        stepIndex: 0,
        runGuide: true,
        steps: [
            {
                target: isMobile() ? '.assets-menu_btn' : '.studio-nav_steps',
                content: <DefaultContentJoyride step='1/6' tourTitle={'joyride.guide.1.step.studio.tour-title'} lineIds={['joyride.guide.1.step.tabs']}/>,
                label: 'Assets Menu',
                disableBeacon: true,
                disableOverlay: false,
                offset: isMobile() ? 10 : -5,
                styles: {
                    buttonSkip: {
                        display: 'none'
                    },
                    tooltip: {
                        marginRight: isMobile() ? undefined : '10px'
                    }
                }
            },
            {
                target: isMobile() ? '.assets-menu_btn' : '.studio-nav_steps',
                content: <DefaultContentJoyride step='2/6' tourTitle={'joyride.guide.1.step.studio.tour-title'} lineIds={['joyride.guide.1.step.notations']}/>,
                label: 'Notation Tab',
                disableBeacon: true,
                disableOverlay: false,
                offset: isMobile() ? 10 : -5,
                styles: {
                    buttonClose: {
                        display: 'none'
                    },
                    tooltip: {
                        marginRight: isMobile() ? undefined : '10px'
                    },
                    buttonBack: {
                        width: '100%',
                        textAlign: 'left',
                        marginLeft: -8
                    }
                }
            }

        ]
    }, {
        routeKey: '/create',
        routeParams: '?guide=true&tabIndex=1',
        label: 'Studio Notation',
        stepIndex: 0,
        runGuide: true,
        steps: [
            {
                target: '.studio-edit-menu',
                content: <DefaultContentJoyride step='3/6' tourTitle={'joyride.guide.1.step.studio.tour-title'}
                                                lineIds={['joyride.guide.1.step.notations.main']}/>,
                label: 'Notation Files',
                disableBeacon: true,
                disableOverlay: false,
                styles: {
                    buttonBack: {
                        display: 'none'
                    },
                    buttonSkip: {
                        display: 'none'
                    }
                },
                placement: 'bottom-end'
            },
            {
                target: '.tab-notation .player-left',
                content: <DefaultContentJoyride step='4/6' tourTitle={'joyride.guide.1.step.studio.tour-title'}
                                                lineIds={['joyride.guide.1.step.notations.player']}/>,
                label: 'Player',
                disableBeacon: true,
                disableOverlay: false,
                styles: {
                    buttonSkip: {
                        display: 'none'
                    },
                    buttonBack: {
                        width: '100%',
                        textAlign: 'left',
                        marginLeft: -8
                    }
                }
            },
            {
                target: isMobile() ? '.tab-notation .player-panel-dots-menu' : '.tab-notation .player-metronome',
                content: <DefaultContentJoyride step='5/6' tourTitle={'joyride.guide.1.step.studio.tour-title'}
                                                lineIds={['joyride.guide.1.step.notations.metronome']}/>,
                label: 'Metronome',
                disableBeacon: true,
                placement: 'top',
                disableOverlay: false,
                styles: {
                    buttonClose: {
                        display: 'none'
                    },
                    buttonSkip: {
                        display: 'none'
                    },
                    buttonBack: {
                        width: '100%',
                        textAlign: 'left',
                        marginLeft: -8
                    }
                }
            },
            {
                target: '.studio-header_save',
                content: <DefaultContentJoyride step='6/6' tourTitle={'joyride.guide.1.step.studio.tour-title'}
                                                lineIds={['joyride.guide.1.step.notations.save']}/>,
                label: 'Save',
                disableBeacon: true,
                disableOverlay: false,
                styles: {
                    buttonClose: {
                        display: 'none'
                    },
                    buttonBack: {
                        width: '100%',
                        textAlign: 'left',
                        marginLeft: -8
                    }
                }
            },
        ]
    }
];
